
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M66.5 1.6c-3.8.8-11.3 3.6-16.5 6.1-8 3.8-10.9 5.9-18.1 13.2C24.6 28.1 22.5 31 18.7 39c-10.4 21.5-10 42.9 1.1 64.5 4.9 9.5 18.2 22.8 27.4 27.6C51 133 54 135.2 54 136c0 3.3-7.4 29.2-16.5 57.5-16 49.8-19.5 62.9-23.4 86C10.5 301.4 10 314 10 386.7c0 78.8 0 78.8 6.6 92.3 5.1 10.3 16.1 21.3 26.4 26.4 14.3 7 3 6.6 193 6.6h171.5l39.5-33.8c35.1-30 40-34.5 44.5-41.3 2.8-4.2 6.2-10.8 7.5-14.5l2.5-6.9.3-84c.4-101.8-.2-114.5-7.9-158-6.9-39-17.8-78.4-32.6-117.5-6.9-18.4-10.8-25.4-19.1-34.2-7.7-8.2-18-14.6-29.7-18.6l-8-2.7L239 .3C96 .2 72.5.3 66.5 1.6M142 44.5c-3.7 8.6-5 18.5-5 37.5v18.1l-31.7-.3-31.8-.3-5.7-2.8C44 85 46.4 50.5 71.5 41.8c4.3-1.5 9.4-1.7 38.7-1.8h33.7zm80 0c-4.7 10.9-5 15.8-5 77.5v58h-40v-56.8c0-61.7.1-62.3 5.5-70.3 6.5-9.3 14.9-12.8 30.7-12.9h10.7zm105 0c-2.6 6.1-5 18.2-5 25.5s2.4 19.4 5 25.5l1.9 4.5H257V83.2c0-18.5.9-23.6 5.5-30.3 3.6-5.1 8.8-9 15-11.1 4.2-1.4 8.9-1.7 28.2-1.8h23.2zm78.6-1c6.7 3.3 12.7 10.4 14.9 17.7 1.1 3.7 1.5 9.8 1.5 21.7-.1 31.7-2.8 48.2-19.4 114.9-8.8 35.1-14.7 63.9-17.8 85.2-2 14.8-2.2 19.6-2.5 102.3l-.4 86.7-159.3-.2-159.3-.3-3.9-2.7c-2.1-1.5-5-4.4-6.4-6.5l-2.5-3.7-.3-70c-.4-74.6 0-84.5 4.4-108.1 3.1-17.1 7.3-32.2 19.9-71.5 10.9-34.1 15.1-48.4 17.9-61.3l1.7-7.7H137v80h120v-80h135v-39.6l-5.8-1.2c-17.4-3.6-27.8-20.8-22.8-37.6 5.4-18 25.2-26.4 42.2-18.1M455.5 186c5.7 34.6 5.7 35.7 6.2 132l.4 89.5-2.3 4.5c-1.7 3.3-6.9 8.5-20.1 19.9l-17.8 15.3.3-72.8c.4-80.3.4-80.1 7.3-114.9 5.7-28.8 21.9-93.9 22.7-91.3.4 1.3 1.9 9.3 3.3 17.8"}})])
          )
        }
      }
    